import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Header from "./Header";

export default function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (!user.onboarded && window.location.pathname !== "/app/onboarding") {
    return <Navigate to="/app/onboarding" replace />;
  }
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 md:py-12">
        <Outlet />
      </main>
    </div>
  );
}
